import { render, staticRenderFns } from "./errorAler.vue?vue&type=template&id=576cbbc2&"
import script from "./errorAler.vue?vue&type=script&lang=js&"
export * from "./errorAler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports